import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Dispositivos } from "../enums/dispositivos.enum";
import { CUSTOM_BREAKPOINTS } from "../enums/breakpoints.enum";

@Injectable({
    providedIn: 'root'
})
export class DispositivoService {

    isMobile: boolean = false;

    constructor(
        private breakpoint: BreakpointObserver,
    ) {}

    private dispositivoSubject = new BehaviorSubject<string>(Dispositivos.LARGE);

    dispositivo$ = this.dispositivoSubject.asObservable();



    BREAKPOINTS = [
        CUSTOM_BREAKPOINTS.XSMALL,
        CUSTOM_BREAKPOINTS.SMALL,
        CUSTOM_BREAKPOINTS.MEDIUM,
        CUSTOM_BREAKPOINTS.LARGE,
        CUSTOM_BREAKPOINTS.XLARGE
    ]

    checarDispositivo() {
        this.breakpoint.observe([...this.BREAKPOINTS]).subscribe(result => {

            if (result.breakpoints[this.BREAKPOINTS[0]]) {
                    this.dispositivoSubject.next(Dispositivos.XSMALL);
            } else if (result.breakpoints[this.BREAKPOINTS[1]]) {
                    this.dispositivoSubject.next(Dispositivos.SMALL);
            } else if (result.breakpoints[this.BREAKPOINTS[2]]) {
                this.dispositivoSubject.next(Dispositivos.MEDIUM);
            } else if (result.breakpoints[this.BREAKPOINTS[3]]) {
                this.dispositivoSubject.next(Dispositivos.LARGE);
            } else if (result.breakpoints[this.BREAKPOINTS[4]]) {
                this.dispositivoSubject.next(Dispositivos.XLARGE);
            } else {
                this.dispositivoSubject.next("ELSE");
            }

        });
    }


}